var map = {
	"./backgrounds/background-01.png": 596,
	"./backgrounds/background-02.png": 597,
	"./backgrounds/background-03.png": 598,
	"./contenido/admindinero4-7-3.png": 599,
	"./contenido/diapositiva-2-(2).png": 600,
	"./contenido/diapositiva-41-(2).png": 601,
	"./contenido/diapositiva-41-(3).png": 602,
	"./contenido/diapositiva-41-(4).png": 603,
	"./contenido/diapositiva-41-(5).png": 604,
	"./contenido/diapositiva-41-(6).png": 605,
	"./contenido/diapositiva-41-(7).png": 606,
	"./contenido/diapositiva-41-(8).png": 607,
	"./contenido/diapositiva-5-(2).png": 608,
	"./contenido/diapositiva-5-(3).png": 609,
	"./contenido/diapositiva_1.png": 610,
	"./contenido/diapositiva_10.png": 611,
	"./contenido/diapositiva_11.png": 612,
	"./contenido/diapositiva_12.png": 613,
	"./contenido/diapositiva_14.png": 614,
	"./contenido/diapositiva_15.png": 615,
	"./contenido/diapositiva_16.png": 616,
	"./contenido/diapositiva_17.png": 617,
	"./contenido/diapositiva_18.png": 618,
	"./contenido/diapositiva_19.png": 619,
	"./contenido/diapositiva_2.png": 620,
	"./contenido/diapositiva_20.png": 621,
	"./contenido/diapositiva_21.png": 622,
	"./contenido/diapositiva_22.png": 623,
	"./contenido/diapositiva_23.png": 624,
	"./contenido/diapositiva_24.png": 625,
	"./contenido/diapositiva_27.png": 626,
	"./contenido/diapositiva_28.png": 627,
	"./contenido/diapositiva_36.png": 628,
	"./contenido/diapositiva_39.png": 629,
	"./contenido/diapositiva_40.png": 630,
	"./contenido/diapositiva_41.png": 631,
	"./contenido/diapositiva_42.png": 632,
	"./contenido/diapositiva_43.png": 633,
	"./contenido/diapositiva_46.png": 634,
	"./contenido/diapositiva_49.png": 635,
	"./contenido/diapositiva_5.png": 636,
	"./contenido/diapositiva_51.png": 637,
	"./contenido/diapositiva_54.png": 638,
	"./contenido/gastos.png": 639,
	"./contenido/personaje_1.png": 640,
	"./design/banco1-1-1.png": 641,
	"./design/banco1-1-2.png": 642,
	"./design/banco1-1-3-2.png": 643,
	"./design/banco1-1-3.png": 644,
	"./design/banco1-11-1.png": 645,
	"./design/banco1-11-2.png": 646,
	"./design/banco1-12-1-1.png": 647,
	"./design/banco1-12-1.png": 648,
	"./design/banco1-2-1.png": 649,
	"./design/banco1-2-2.png": 650,
	"./design/banco1-3-1.png": 651,
	"./design/banco1-3-2.png": 652,
	"./design/banco1-4-2.png": 653,
	"./design/banco1-6-1.png": 654,
	"./design/banco1-9-1.png": 655,
	"./design/banco1-9-2.png": 656,
	"./design/banco3-1-1.png": 657,
	"./design/banco3-1-1_2.png": 658,
	"./design/banco3-1-1_3.png": 659,
	"./design/banco4-1-1.png": 660,
	"./design/banco4-1-2.png": 661,
	"./design/banco4-2-1.png": 662,
	"./design/banco4-2-2.png": 663,
	"./design/banco4-2-3.png": 664,
	"./design/banco4-3-1.png": 665,
	"./design/banco4-3-2.png": 666,
	"./design/banco4-4-1.png": 667,
	"./design/banco4-4-7.png": 668,
	"./design/banco5-1-1.png": 669,
	"./design/banco5-1-2.png": 670,
	"./design/banco5-1-3.png": 671,
	"./design/banco5-4-2.png": 672,
	"./design/banco5-4-3.png": 673,
	"./design/banco7-1-1.png": 674,
	"./design/banco7-1-2.png": 675,
	"./design/banco7-2-2.png": 676,
	"./design/banco8-1-1.png": 677,
	"./design/banco8-1-2.png": 678,
	"./design/banco8-1-3.png": 679,
	"./design/bancocuentac-1.png": 680,
	"./design/bancocuentac-2-2.png": 681,
	"./design/bancocuentac-2.png": 682,
	"./design/bancocuentac-3.png": 683,
	"./design/bancocuentac-4.png": 684,
	"./design/final3.png": 685,
	"./design/final4.png": 686,
	"./design/gray-arrow.png": 687,
	"./design/red-arrow.png": 688,
	"./design/texture.png": 689,
	"./logos-icons/access-buttons.png": 690,
	"./logos-icons/bullet-dav-1.png": 691,
	"./logos-icons/bullet-dav-2.png": 692,
	"./logos-icons/bullet-dav-ok-red.png": 693,
	"./logos-icons/bullet-dav-ok.png": 694,
	"./logos-icons/bullet-ok-roja.png": 695,
	"./logos-icons/cerrar_blan.png": 696,
	"./logos-icons/davi-header-2.png": 697,
	"./logos-icons/davi-header.png": 156,
	"./logos-icons/flechas-nav.png": 698,
	"./logos-icons/glosario.png": 699,
	"./logos-icons/glosarioIcono.png": 700,
	"./logos-icons/hamb.png": 701,
	"./logos-icons/iconos-footer.png": 702,
	"./logos-icons/menu-foot.png": 703,
	"./logos-icons/mis-finanzas.png": 704,
	"./logos-icons/ok-bot.png": 705,
	"./logos-icons/ok-bullet.png": 706,
	"./logos-icons/wrong-bullet.png": 707
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1065;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.png$
// module id = 1065
// module chunks = 1